<template>
  <div class="animated fadeIn">
    <Tables
      ref="tableGrid"
      :columns="[
        'Cód.',
        'Tipo',
        'Quadro',
        'Val. Inicial',
        'Val. Final',
        $lang.Common.DataTable.Actions
      ]"
      :showNew="true"
      :showSearch="false"
      :showReload="true"
      :showTipFooter="false"
      v-on:New="onNew"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.codigo ? obj.codigo : ''"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="obj.valorInicialCredito ? 'Crédito' : 'Débito'"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="getBoardName(obj.boardId)"
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.valorInicialCredito
              ? valueToMoney(obj.valorInicialCredito)
              : valueToMoney(obj.valorInicialDebito)
          "
        />
        <TableColumn
          :IsText="true"
          v-on:Edit="onEdit(obj)"
          :status="obj.inative ? 0 : 1"
          :value="
            obj.valorFinalCredito
              ? valueToMoney(obj.valorFinalCredito)
              : valueToMoney(obj.valorFinalDebito)
          "
        />
        <TableColumn
          :IsActionsButtons="true"
          :HasChange="false"
          v-on:Delete="onDelete(obj)"
          :status="obj.status"
        />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="$emit('New')"
          v-b-tooltip.hover
          :title="'Clique para cadastrar'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import MovimentationCarRepository from '@/shared/http/repositories/configurations/movimentationCards.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'

export default {
  name: 'MovimentationList',
  mixins: [ActionsForm],
  data () {
    return {
      boards: null
    }
  },
  created () {
    this.loadBoards()
  },
  methods: {
    onLoad () {
      loading.push()
      MovimentationCarRepository.GetAllPaging(
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      MovimentationCarRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    loadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          let options = res.data.content.map((x) => ({
            value: x.id,
            text: x.nome
          }))

          this.boards = options
        })
        .catch(this.onException)
    },
    getBoardName (id) {
      let option = this.boards.find((board) => board.value === id)
      return option.text
    },
    valueToMoney (value) {
      if (value) {
        return value.toLocaleString('pt-Br', {
          style: 'currency',
          currency: 'BRL'
        })
      } else {
        return 'R$ 0,00'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/cardMovimentation/components/list/MovimentationList.vue